import { render, staticRenderFns } from "./appraise.vue?vue&type=template&id=52b6025e&scoped=true"
import script from "./appraise.vue?vue&type=script&lang=js"
export * from "./appraise.vue?vue&type=script&lang=js"
import style0 from "./appraise.vue?vue&type=style&index=0&id=52b6025e&prod&lang=less&scoped=true"
import style1 from "./appraise.vue?vue&type=style&index=1&id=52b6025e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b6025e",
  null
  
)

export default component.exports